"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Clock, TriangleAlert, ShieldAlert, FileText, PenTool } from "lucide-react";
const faqs = [{
  id: "item-1",
  question: "RESERVATIONS & CONFIRMATION",
  answer: "All private transfers must be reserved at least 2 hours in advance to ensure chauffeur availability. You will receive an instant email confirmation, followed by specific chauffeur details (name, photo, and vehicle plate) sent via SMS 60 minutes before your scheduled pickup at SFO, OAK, or SJC.",
  iconName: "Clock"
}, {
  id: "item-2",
  question: "WAIT TIME, MEET & GREET, AND NO‑SHOW POLICY",
  answer: "We offer 60 minutes of complimentary wait time for all airport arrivals and 15 minutes for residential or corporate pickups. For airport transfers, your chauffeur will meet you at the designated 'Meet & Greet' area with a digital name sign. No-shows after the grace period without contact will be charged in full.",
  iconName: "TriangleAlert"
}, {
  id: "item-3",
  question: "CHILD SEATS & SPECIAL REQUESTS",
  answer: "Complimentary child seats, including rear-facing, forward-facing, and boosters, are available upon request to ensure the safety of our youngest passengers. Please specify your needs during booking. We also accommodate special requests for specific beverages, climate settings, or route preferences.",
  iconName: "PenTool"
}, {
  id: "item-4",
  question: "CANCELLATION & MODIFICATIONS",
  answer: "Cancellations are free of charge up to 24 hours before your scheduled pickup. Within 24 hours, a 50% fee applies. No-shows or cancellations within 2 hours of the booking time will be charged in full. Rescheduling is subject to vehicle availability and may incur an adjustment fee.",
  iconName: "FileText"
}, {
  id: "item-5",
  question: "FLEET, SAFETY & DISCRETION",
  answer: "Our fleet consists of the latest premium vehicles, deep-cleaned daily and equipped with Wi-Fi and amenities. All chauffeurs are fully licensed, background-checked, and trained in executive protection. Discretion is our hallmark, and all staff sign strict confidentiality agreements to protect your privacy.",
  iconName: "ShieldAlert"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "Clock":
      return <Clock className="size-6 text-primary shrink-0" />;
    case "TriangleAlert":
      return <TriangleAlert className="size-6 text-primary shrink-0" />;
    case "ShieldAlert":
      return <ShieldAlert className="size-6 text-primary shrink-0" />;
    case "FileText":
      return <FileText className="size-6 text-primary shrink-0" />;
    case "PenTool":
      return <PenTool className="size-6 text-primary shrink-0" />;
    default:
      return <TriangleAlert className="size-6 text-primary shrink-0" />;
  }
};
export default function TheFinePrint() {
  return <section data-section-id="101503" id="traveler-inquiries" className="dark bg-background text-foreground py-24 px-6 sm:px-8 lg:px-12 relative border-t border-border/20">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-primary)_1px,transparent_1px)] bg-[size:32px_32px]"></div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-6xl font-serif font-bold tracking-tighter uppercase text-primary mb-4">
            Traveler Inquiries
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-mono uppercase tracking-widest">
            Executive Standards
          </p>
        </div>

        <div className="border-y border-primary/30 bg-card/50 backdrop-blur-md shadow-2xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="border-b border-border/20 last:border-b-0 data-[state=open]:bg-accent/10 transition-colors duration-500 px-4 md:px-8">
                <AccordionTrigger className="font-sans font-semibold text-base md:text-lg py-6 hover:text-primary hover:no-underline [&[data-state=open]]:text-primary gap-6 text-left">
                  <div className="flex items-center gap-4 flex-1">
                    {getIcon(faq.iconName)}
                    <span className="tracking-tight uppercase">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-8 pt-2 pl-14 md:pl-16 pr-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
        
        {}
        <div className="h-1 w-full mt-12 bg-[repeating-linear-gradient(90deg,var(--color-primary)_0,var(--color-primary)_4px,transparent_4px,transparent_12px)] opacity-20"></div>
      </div>
    </section>;
}